export class MaterialData {
    public scaleStoff = {x: 0, y: 0};
    public scaleStoff_neu = {x: 0, y: 0};
    public overrideScale = false;
    public alphaMap = "";
    public alphaMap_neu = "";
    public specularMap = "";
    public bumpScale = 1.0;
    public bumpMap = "";
    public normalScale = 1.0;
    public normalMap = "";
    public shininess = 1.0;
    public specular = 0.0;
    public specularMin = 0.0;
    public isDroppable = false;
    public overlayMap = "";
    public overlayScale = {x:1, y:1}
    public overlayIntensity = 1;
    public overlayHelligkeitsSummand = 0;
    public overlayAnzeigenAufFarbenIntArray:number[]=[];
    public innenseiteAufhellen = true;
    public schwarzAufhellenImDruckbereich = false;

    private static getFirstDefined(...valueArray:any[]) {
        return valueArray.find(v=>typeof(v) !== "undefined");
    }

    public initFromJSONData(jsondata) {
        const set = MaterialData.getFirstDefined;
        this.scaleStoff = set(jsondata.scaleStoff, this.scaleStoff);
        this.overrideScale = set(jsondata.overrideScale, this.overrideScale);
        this.alphaMap = set(jsondata.alphaMap, this.alphaMap);
        this.specularMap = set(jsondata.specularMap, this.specularMap);
        this.bumpScale = set(jsondata.bumpScale, this.bumpScale);
        this.bumpMap = set(jsondata.bumpMap, this.bumpMap);
        this.normalScale = set(jsondata.normalScale, this.normalScale);
        this.shininess = set(jsondata.shininess, this.shininess);
        this.normalMap = set(jsondata.normalMap, this.normalMap);
        this.specular = set(jsondata.specular, this.specular);
        this.specularMin = set(jsondata.specularMin, this.specularMin);
        this.overlayMap = set(jsondata.overlayMap, this.overlayMap);
        this.overlayHelligkeitsSummand = set(jsondata.overlayHelligkeitsSummand, this.overlayHelligkeitsSummand);
        this.overlayScale = set(jsondata.overlayScale, this.overlayScale);
        this.overlayAnzeigenAufFarbenIntArray = set(jsondata.overlayAnzeigenAufFarbenIntArray,this.overlayAnzeigenAufFarbenIntArray);
        this.isDroppable = set(jsondata.isDroppable, this.isDroppable);
        this.overlayIntensity = set(jsondata.overlayIntensity, this.overlayIntensity);
        this.innenseiteAufhellen = set(jsondata.innenseiteAufhellen, this.innenseiteAufhellen)
        this.schwarzAufhellenImDruckbereich = set(jsondata.schwarzAufhellenImDruckbereich, this.schwarzAufhellenImDruckbereich)
    }
}
